<template>
  <div class="count-wrap" v-if="nextLottery">
    <p>
      <span>{{nextLottery.period ? `第${nextLottery.period}期` : '当前暂无期数'}}</span>
      <span
        class="center blue"
      >距封盘：{{nextLottery.block_time>0? nextLottery.block_time + "秒":'已封盘' }}</span>
      <span
        class="center red"
      >距开奖： {{ nextLottery.remain_time > 0?nextLottery.remain_time+ "秒": '--'}}</span>
    </p>
    <p>
      <span>可用金额：</span>
      <span class="red" v-if="user.status==3">冻结</span>
      <span class="red" v-else>{{user.credit_balance}}</span>

      <span>今日输赢：</span>
      <span class="red">{{user.today_bet_result}}</span>
    </p>
  </div>
</template>

<script>
import { getUserInfo } from "@/service/user";
import { mapActions } from 'vuex';
export default {
  name: "count-wrap",
  props: {
    nextLottery: {
      type: Object,
      default: null
    },
    lottery_type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      r_time: 0,
      b_time: 0,
      time3: 0,
      user: 0,
      timer: null,
      timer2: null
    };
  },
  created() {
    this.getUser();
  },

  methods: {
    ...mapActions("root", ["getLotteryLongQueue"]),
    async getUser() {
      this.user = await getUserInfo();
    }
  },

  mounted() {
    let _this = this;
    this.timer = setInterval(function() {
      _this.nextLottery.remain_time--;
      _this.nextLottery.block_time--;
      if (_this.nextLottery.remain_time <= 0) {
        _this.$parent.getHeadres(_this.lottery_type);
      }
    }, 20000);
    this.timer2 = setInterval(function() {
      _this.getUser();
      _this.getLotteryLongQueue({ lottery_type: _this.lottery_type });
      _this.$parent.getHeadres(0);
    }, 20000);
  },

  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.timer2);
  }
};
</script>

<style scoped lang="less">
.center {
  text-align: center;
}
.right {
  text-align: right;
}
.count-wrap {
  color: #333;
  padding: 10px;
  font-size: 26px;
  background-color: #fff;
  p {
    display: flex;
    padding: 10px;
    justify-content: center;
    &:nth-of-type(1) {
      span {
        flex: 1;
        white-space: nowrap;
      }
    }
    &:nth-of-type(2) {
      span {
        padding: 0 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/count-wrap/index.vue